import React from 'react';
import {Route, IndexRoute, IndexRedirect} from 'react-router';
import {basePath} from './constants/public-routes';

//Containers
import App2 from "./modules/app/containers/App";

import BreadcrumbContainer from './modules/breadcrumb/containers/BreadcrumbContainer';

import LawsContainer from './modules/laws/containers/LawsContainer';
import LawContainer from './modules/laws/containers/LawContainer';
import ArticleContainer from './modules/articles/containers/ArticleContainer';
import ElementContainer from './modules/elements/containers/ElementContainer';
import ElementRedirect from './modules/elements/components/ElementRedirect';
import ElementAnnotationsRedirect from './modules/elements/components/ElementAnnotationsRedirect';
import ElementAnnotationRedirect from './modules/elements/components/ElementAnnotationRedirect';

//Home
import Home from './modules/home/containers/Home';

//Structure
import StructureAbout from './modules/structures/components/StructureAbout';
import StructureTOC from './modules/structures/containers/StructureTOC';
import StructureVersions from './modules/structures/components/StructureVersions';
import StructureLanguages from './modules/structures/components/StructureLanguages';

//Article
import ArticleAbout from './modules/articles/components/ArticleAbout';
import ArticleText from './modules/articles/components/ArticleText';
import ArticleVersions from './modules/articles/components/ArticleVersions';
import ArticleVersionContainer from './modules/articles/components/ArticleVersionContainer';
import ArticleLanguageContainer from './modules/articles/components/ArticleLanguageContainer';
import ArticleCompareLanguage from './modules/articles/containers/ArticleCompareLanguage';
import ArticleCompareVersion from './modules/articles/containers/ArticleCompareVersion';
import ArticleLanguages from './modules/articles/components/ArticleLanguages';

//Annotation
import AnnotationAbout from './modules/annotations/components/AnnotationAbout';
import AnnotationText from './modules/annotations/components/AnnotationText';
import AnnotationLanguages from './modules/annotations/components/AnnotationLanguages';
import AnnotationsContainer from './modules/annotations/containers/AnnotationsContainer';

//Tags
import TagsContainer from './modules/tags/containers/TagsContainer';

//
import PrintContainer from './modules/print/containers/PrintContainer';
import PrintQueueContainer from './modules/print/containers/PrintQueueContainer';

//Concepts
import ConceptContainer from './modules/concepts/containers/ConceptContainer';
import About from "./modules/helptexts/About";
import Disclaimer from "./modules/helptexts/Disclaimer";
import Contactmailform from "./modules/contactmail/containers/contactmailform";

let articleVersions = (
  <Route name="otherVersions" path="articleversions" component={ArticleVersionContainer}
         fetchData={{fn: 'fetchArticleVersions', params: [':articleId', 'date']}}>
    <IndexRedirect to="index"/>
    <Route name="differentVersion" path="index" component={ArticleVersions} breadcrumbIgnore/>
    <Route name=":dateVersion" path=":dateVersion" component={ArticleCompareVersion}/>
  </Route>
);

let articleLanguages = (
  <Route name="differentLanguages" path="articlelanguages" component={ArticleLanguageContainer}
         fetchData={{fn: 'fetchArticleVersions', params: [':articleId', 'language']}}>
    <IndexRedirect to="index"/>
    <Route name="differentLanguages" path="index" component={ArticleLanguages} breadcrumbIgnore/>
    <Route name=":langVersion" path=":langVersion" component={ArticleCompareLanguage}/>
  </Route>
);

let elementRoutes = (
  <Route path="element/:elementId" component={ElementContainer} breadcrumbIgnore>
    <IndexRedirect to="annotations"/>
    <Route name="annotations" path="annotation" component={AnnotationsContainer} fetchData={{fn: 'fetchElementAnnotations', params: [':elementId']}}/>
    <Route name="annotation" path="annotation/:annotationId" component={AnnotationText} fetchData={{fn: 'fetchAnnotation', params: [':annotationId']}}/>
    <Route name="about" path="elementabout" component={AnnotationAbout}/>
    <Route name="differentLanguages" path="elementLanguages" component={AnnotationLanguages}/>
  </Route>
);

function forceNoTrailingSlash(nextState, replace) {
  const path = nextState.location.pathname;
  if (path.slice(-1) === '/') {
    replace({
      ...nextState.location,
      pathname: path.slice(0, -1)
    });
  }
}

function forceNoTrailingSlashOnChange(prevState, nextState, replace) {
  forceNoTrailingSlash(nextState, replace);
}

let redirectParent = function (obj, replace) {
  const relative = '../';
  let path = obj.location.pathname;
  path = absolute(path, relative);
  if (path.slice(-1) === '/') {
    path = path.slice(0, -1);
  }
  replace(path);

  function absolute(base, relative) {
    let stack = base.split("/"),
      parts = relative.split("/");
    if (base.slice(-1) === '/') {
      stack.pop(); // remove current file name (or empty string)
                   // (omit if "base" is the current folder without trailing slash)
    }
    for (let i = 0; i < parts.length; i++) {
      if (parts[i] === ".")
        continue;
      if (parts[i] === "..")
        stack.pop();
      else
        stack.push(parts[i]);
    }
    return stack.join("/");
  }
};

// TODO check all fetches
export default (
  <Route path={basePath} name={basePath} breadcrumbIgnore>
    <IndexRedirect to="nl"/>
    <Route path=":lang" name="home" component={App2}>
      <Route name="noSlash" breadcrumbIgnore onEnter={forceNoTrailingSlash} onChange={forceNoTrailingSlashOnChange} on component={BreadcrumbContainer}>
        {/*TODO langcontainer*/}
        <Route path="about" component={About} breadcrumbIgnore/>
        <Route path="contact" component={Contactmailform} breadcrumbIgnore/>
        <Route path="disclaimer" component={Disclaimer} breadcrumbIgnore/>
        <IndexRoute name="Home" component={Home} fetchData={{fn: 'fetchAnnotatedTexts', params: [':lang']}} breadcrumbIgnore/>
        <Route path="dia" name="dia" breadcrumbIgnore>
          <IndexRoute onEnter={redirectParent}/>
          <Route path="tags" component={TagsContainer} name="tags"/> {/* breadcrumb */}
          <Route path="structure" name="annotatedTexts">
            <IndexRoute component={LawsContainer} fetchData={{fn: 'fetchAnnotatedTexts', params: [':lang']}} breadcrumbIgnore/>
            <Route path=":structureId" name=":structureId" component={LawContainer} fetchData={{fn: 'fetchStructure', params: [':structureId']}}>
              <IndexRedirect to="toc"/>
              <Route name="tableOfContents" path="toc" component={StructureTOC} breadcrumbIgnore/>
              <Route name="aboutThisText" path="about" component={StructureAbout}/>
              <Route name="otherVersions" path="versions" component={StructureVersions}/>
              <Route name="differentLanguages" path="languages" component={StructureLanguages}/>
              <Route path="element" name="redirect">
                <IndexRoute onEnter={redirectParent}/>
                <Route component={ElementContainer} path=":elementId" name=":elementId">
                  {/* I cannot fetch beforehand, because redirecting from a component doesn't bode well with serverside rendering */}
                  <IndexRedirect to="redirect"/>
                  <Route path="redirect" name="redirect" component={ElementRedirect} breadcrumbIgnore/>
                  <Route path="annotation" name="annotation" breadcrumbIgnore>
                    <IndexRedirect to="redirect"/>
                    <Route path="redirect" name="redirect" component={ElementAnnotationsRedirect} breadcrumbIgnore/>
                    <Route path=":annotationId" name=":annotationId" component={ElementAnnotationRedirect} breadcrumbIgnore/>
                  </Route>
                </Route>
              </Route>
              <Route path="article" name="article" breadcrumbIgnore>
                <IndexRoute onEnter={redirectParent}/>
                <Route path=":articleId" name=":articleId" component={ArticleContainer} fetchData={{fn: 'fetchArticle', params: [':articleId']}}>
                  <IndexRedirect to="articletext"/>
                  <Route name="text" path="articletext" component={ArticleText} breadcrumbIgnore/>
                  <Route name="aboutThisText" path="articleabout" component={ArticleAbout}/>
                  {articleVersions}
                  {articleLanguages}
                  {elementRoutes}
                </Route>
              </Route>
            </Route>
          </Route> {/* breadcrumb */}
          <Route path="concept" name="concept" breadcrumbIgnore>
            <IndexRoute onEnter={redirectParent}/>
            <Route path=":conceptId" name=":conceptId" component={ConceptContainer}/>
          </Route>
          <Route path="print" name="print" breadcrumbIgnore>
            <IndexRoute name="print" breadcrumbIgnore component={PrintContainer}/>
            <Route path="queue" name="printQueue" component={PrintQueueContainer}/> {/* breadcrumb */}
          </Route>
        </Route>
      </Route>
    </Route>
  </Route>
);



/** WEBPACK FOOTER **
 ** ./src/routes.js
 **/